import React from 'react';

const IconLoader = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100">
    <g fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M 50, 10 L 90, 90 L 10, 90 Z" /> {/* This could be the outer shape */}
      <text x="50%" y="60%" dominantBaseline="middle" textAnchor="middle" fontSize="50" fill="currentColor" id="A">
        A
      </text>
    </g>
  </svg>
);

export default IconLoader;
